import { GD } from './GD';
import { User } from './User';
var LocaleStore = /** @class */ (function () {
    function LocaleStore(_a) {
        var customId = _a.customId;
        this.gd = new GD();
        this.user = new User();
        if (customId) {
            this.custom = JSON.parse(localStorage.getItem(customId) || '{}');
        }
    }
    LocaleStore.prototype.storeGD = function (gd) {
        this.gd = Object.assign({}, this.gd, gd);
        localStorage.setItem('gd', JSON.stringify(this.gd));
        console.warn('storeCustom is deprecated - use storage.write', 'gd');
    };
    LocaleStore.prototype.storeUser = function (user) {
        this.user = Object.assign({}, this.user, user);
        localStorage.setItem('user', JSON.stringify(this.user));
        console.warn('storeCustom is deprecated - use storage.write', 'user');
    };
    LocaleStore.prototype.storeCustom = function (id, data) {
        this.custom = Object.assign({}, this.custom, data);
        localStorage.setItem(id, JSON.stringify(this.custom));
        console.warn('storeCustom is deprecated - use storage.write', id);
    };
    return LocaleStore;
}());
export default LocaleStore;
//# sourceMappingURL=LocalStore.js.map